import { render } from "./WidgetIntegrationGuide.vue?vue&type=template&id=63eb7670&scoped=true"
import script from "./WidgetIntegrationGuide.vue?vue&type=script&lang=js"
export * from "./WidgetIntegrationGuide.vue?vue&type=script&lang=js"

import "./WidgetIntegrationGuide.vue?vue&type=style&index=0&id=63eb7670&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63eb7670"]])

export default __exports__